import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ErrorDetails, OwnersCheckingAccountResponseDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetOwnersCheckingAccountsCommand extends IRequestCommand<
OwnersCheckingAccountResponseDTO,
  ErrorDetails,
  IGetOwnersCheckingAccountCommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

    public override setParameters(parameters: IGetOwnersCheckingAccountCommandParameters) {
      this.urlSections.push('checking-accounts');
      this.urlSections.push('carrier');
      this.urlSections.push(`${parameters.carrierId}`);
      this.urlSections.push('owners');
      this.urlSections.push('paginated');
      this.paramsSections.push(`page=${parameters.page}`);
      this.paramsSections.push(`size=${parameters.size}`);
      this.paramsSections.push(`column=${parameters.column}`);
      this.paramsSections.push(`sort=${parameters.sort}`);
      this.paramsSections.push(`find=${parameters.find}`);
      this.composeUrl();
    }
}
export interface IGetOwnersCheckingAccountCommandParameters {
    carrierId: number;
    page?: number;
    size?: number;
    column?: string;
    sort?: string;
    find?: string;
}

